export enum ButtonState {
	UP,
	DOWN,
	OVER,
	DISABLED,
	SELECTED,
}

interface StateMap {
	[state: number]: any;
}

export class Button extends PIXI.Sprite {
	protected _state: ButtonState;
	protected _frames: StateMap = {};
	protected _callback: Function;
	private _callbackParams: any;
	protected _tapDownCallback: Function;
	protected _mouseOutCallback: Function;
	protected _over: boolean;

	constructor(callback?: Function) {
		super();

		this._callback = callback;

		this.setupInputCallbacks();
	}

	public enable(): void {
		if (this._over) {
			this.setState(ButtonState.OVER);
		} else {
			this.setState(ButtonState.UP);
		}

		this.interactive = true;
		this.buttonMode = true;
	}

	public disable(): void {
		this.setState(ButtonState.DISABLED);

		this.interactive = false;
		this.buttonMode = false;
	}

	protected setupInputCallbacks(): void {
		this.on('mousedown', this.onMouseDown);
		this.on('mouseup', this.onMouseUp);
		this.on('mouseover', this.onMouseOver);
		this.on('mouseout', this.onMouseOut);
		this.on('click', this.onClick);

		this.on('tap', this.onClick);
		this.on('touchstart', this.onMouseDown);
		this.on('touchendoutside', this.onMouseOut);
		this.on('touchend', this.onMouseUp);
		this.on('touchleave', this.onMouseUp);
	}

	protected updateFrame(): void {}

	protected onMouseUp(): void {
		this.setState(ButtonState.UP);
	}

	protected onMouseDown(): void {
		this.setState(ButtonState.DOWN);
		this._tapDownCallback && this._tapDownCallback();
	}

	protected onMouseOver(): void {
		this._over = true;
		this.setState(ButtonState.OVER);
	}

	protected onMouseOut(): void {
		this._mouseOutCallback && this._mouseOutCallback();
		this._over = false;
		this.setState(ButtonState.UP);
	}

	protected onClick(): void {
		this.setState(ButtonState.OVER);

		if (this._callback) {
			this._callback(this._callbackParams);
		} else {
			console.warn('There is no a callback.');
		}
	}

	protected cleanFrame(): void {}

	protected setState(value: ButtonState, cleanFrame: boolean = true): void {
		if (this._state !== value) {
			this._state = value;

			if (cleanFrame) {
				this.cleanFrame();
			}
			this.updateFrame();
		}
	}

	public set callback(value: Function) {
		this._callback = value;
	}

	public set callbackParams(value: any) {
		this._callbackParams = value;
	}

	public set tapDownCallback(value: Function) {
		this._tapDownCallback = value;
	}

	public set mouseOutCallback(value: Function) {
		this._mouseOutCallback = value;
	}

	public get currentState(): ButtonState {
		return this._state;
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/core/src/display/Button.ts